/**
 * Product Repository
 * Maintains backward compatibility while using BaseRepository internally
 */

import { productQueries } from './products/productQueries';
import { productMutations } from './products/productMutations';
import { productSearch } from './products/productSearch';
import { productStats } from './products/productStats';

export { productQueries, productMutations, productSearch, productStats };

export const productRepository = {
  getFeaturedProducts: productQueries.getFeaturedProducts.bind(productQueries),
  getAllProducts: productQueries.getAllProducts.bind(productQueries),
  getProductsByCategory: productQueries.getProductsByCategory.bind(productQueries),
  getProductById: productQueries.getProductById.bind(productQueries),
  getProductsByIds: productQueries.getProductsByIds.bind(productQueries),
  getProductsByShopIds: productQueries.getProductsByShopIds.bind(productQueries),
  getUsedProducts: productQueries.getUsedProducts.bind(productQueries),
  getPendingProducts: productQueries.getPendingProducts.bind(productQueries),
  getActiveProducts: productQueries.getActiveProducts.bind(productQueries),
  getProductsByShop: productQueries.getProductsByShop.bind(productQueries),
  getProductsByPartner: productQueries.getProductsByPartner.bind(productQueries),
  getProductStats: productStats.getProductStats.bind(productStats),
  addProducts: productMutations.addProducts.bind(productMutations),
  deleteAllProducts: productMutations.deleteAllProducts.bind(productMutations),
  updateProduct: productMutations.updateProduct.bind(productMutations),
  createProduct: productMutations.createProduct.bind(productMutations),
  searchProducts: productSearch.searchProducts.bind(productSearch),
  getRecommendedProducts: productQueries.getRecommendedProducts.bind(productQueries),
  getLowStockProducts: productQueries.getLowStockProducts.bind(productQueries),
  decreaseStock: productMutations.decreaseStock.bind(productMutations),
};
